<template>
  <div class="page">
    <div class="headerNav">
      <div class="nav">
        <div class="nav_content">我的订单</div>
      </div>
      <div class="nav-left" @click="goBack"><img src="../../assets/new/left_b.svg" alt="" /></div>
    </div>
    <div class="header">
      <van-tabs @click="onClick" color="#2A70F2" title-active-color="#2A70F2">
        <van-tab title="全部">
          <div class="group_1" v-if="orderList.length > 0">
            <div class="box_1" v-for="item in orderList" :key="item.id">
              <div class="title">
                <div class="title_1">
                  <div class="text_1">{{ item.className }}</div>
                  <div class="text_2">订单编号：{{ item.ordNo }}</div>
                </div>
                <div class="title_icon" v-if="item.ordStatus == '20'">已支付</div>
                <div class="title_icon1" v-if="item.ordStatus == '01'">未支付</div>
                <div class="title_icon" v-if="item.ordStatus == '00'">已取消</div>
                <div class="title_icon" v-if="item.ordStatus == '10'">已退款</div>
                <div class="title_icon1" v-if="item.ordStatus == '02'">支付中</div>
                <div class="title_icon" v-if="item.ordStatus == '11'">部分退款</div>
                <div class="title_icon" v-if="item.ordStatus == '12'">申请退款</div>
              </div>
              <van-divider />
              <div class="info">
                <div class="info-left">
                  <img :src="item.image" alt="" v-if="item.image != null && item.image != '' && item.ordType != '05'" />
                  <img src="../../assets/new/orderVip.png" alt="" v-if="item.ordType == '05'" />
                  <img src="../../assets/new/xiaoBg.png" alt="" v-if="(item.image == null || item.image == '') && item.ordType != '05'" />
                </div>
                <div class="info-right">
                  <div class="text_3">下单时间：{{ item.createTime }}</div>
                  <div class="text_3">
                    订单类型：{{
                      item.ordType == '01'
                        ? '个人'
                        : item.ordType == '02'
                        ? '集体'
                        : item.ordType == '03'
                        ? '机构'
                        : item.ordType == '04'
                        ? '单课购买'
                        : item.ordType == '05'
                        ? '年度会员'
                        : '职业培训'
                    }}
                  </div>
                  <div class="text_4"><span class="text_5">¥</span>{{ item.ordTotalMoney.toFixed(2) }}</div>
                </div>
              </div>
              <van-divider />
              <div class="btn" v-if="item.ordStatus == '01' || item.ordStatus == '00'">
                <div class="btn_2" @click="delOrder(item.id, '01')" v-if="item.ordStatus == '00'">删除订单</div>
                <div class="btn_2" @click="cancelOrder(item, '01')" v-if="item.ordStatus == '01'">取消订单</div>

                <div class="btn_3" v-if="item.ordStatus == '01'" @click="toOrder(item)">去支付</div>
              </div>
               
              <!-- <div v-if="item.ordStatus == '20'" style="display: flex;justify-content: flex-end;">
                 <div class="btn_1" @click="handleinvoice(item)" v-if="item.invoiceClaimType!='02'&&item.ordMoneysum>0">开发票</div></div> -->
              <!-- <div class="btn_5" v-if="item.ordStatus == '20' && item.ordType == '01'">
                <div style="display: flex; justify-content: space-around" v-if="item.status == '02'">
                  <div style="display: flex; flex-direction: column; justify-content: center; align-items: center">
                    <div class="ptText_1">拼团中</div>
                    <div class="ptText_2">拼团状态</div>
                  </div>
                  <div style="display: flex; flex-direction: column; justify-content: center; align-items: center">
                    <div class="ptText_1">{{ formatTime(item.remainingMillis) }}</div>
                    <div class="ptText_2">拼团倒计时</div>
                  </div>
                  <div style="display: flex; flex-direction: column; justify-content: center; align-items: center">
                    <div class="ptText_3" @click="inviteNewUsers(item.shareUrl)">复制链接</div>
                    <div class="ptText_2">拼团链接</div>
                  </div>
                </div>
                <div style="display: flex; flex-direction: column; align-items: center" v-if="item.status == '01'">
                  <div class="ptText_4"><span>拼团状态：</span> <span style="color: #ff2d31">拼团失败</span></div>

                  <div class="ptText_5" @click="gotoXuanke">去选课再拼团 <img src="../../assets/new/right-pt.png" alt="" /></div>
                </div>
                <div style="display: flex; flex-direction: column; align-items: center" v-if="item.status == '04'">
                  <div class="ptText_4"><span>拼团状态：</span> <span style="color: #ff8833">拼团成功</span></div>
                </div>
              </div> -->
            </div>
            <div @click="loadMore" v-if="hasMore" class="load-more">点击加载更多</div>
            <div v-else class="no-more">没有更多数据了~</div>
          </div>
          <!-- 空状态 -->
          <van-empty description="暂无订单" v-if="orderList.length == 0" />
        </van-tab>
        <van-tab title="已支付">
          <div class="group_1" v-if="orderList.length > 0">
            <div class="box_1" v-for="item in orderList" :key="item.id">
              <div class="title">
                <div class="title_1">
                  <div class="text_1">{{ item.className }}</div>
                  <div class="text_2">订单编号：{{ item.ordNo }}</div>
                </div>
                <div class="title_icon" v-if="item.ordStatus == '20'">已支付</div>
                <div class="title_icon1" v-if="item.ordStatus == '01'">未支付</div>
                <div class="title_icon" v-if="item.ordStatus == '00'">已取消</div>
                <div class="title_icon" v-if="item.ordStatus == '10'">已退款</div>
                <div class="title_icon1" v-if="item.ordStatus == '02'">支付中</div>
                <div class="title_icon" v-if="item.ordStatus == '11'">部分退款</div>
                <div class="title_icon" v-if="item.ordStatus == '12'">申请退款</div>
              </div>
              <van-divider />
              <div class="info">
                <div class="info-left">
                  <img :src="item.image" alt="" v-if="item.image != null && item.image != '' && item.ordType != '05'" />
                  <img src="../../assets/new/orderVip.png" alt="" v-if="item.ordType == '05'" />
                  <img src="../../assets/new/xiaoBg.png" alt="" v-if="(item.image == null || item.image == '') && item.ordType != '05'" />
                </div>
                <div class="info-right">
                  <div class="text_3">下单时间：{{ item.createTime }}</div>
                  <div class="text_3">
                    订单类型：{{
                      item.ordType == '01'
                        ? '个人'
                        : item.ordType == '02'
                        ? '集体'
                        : item.ordType == '03'
                        ? '机构'
                        : item.ordType == '04'
                        ? '单课购买'
                        : item.ordType == '05'
                        ? '年度会员'
                        : '职业培训'
                    }}
                  </div>
                  <div class="text_4"><span class="text_5">¥</span>{{ item.ordTotalMoney.toFixed(2) }}</div>
                </div>
              </div>
              <van-divider />
               <!-- <div v-if="item.ordStatus == '20'" style="display: flex;justify-content: flex-end;">
                 <div class="btn_1" @click="handleinvoice(item)" v-if="item.invoiceClaimType!='02'&&item.ordMoneysum>0">开发票</div></div> -->
              <!-- <div class="btn_5" v-if="item.ordStatus == '20' && item.ordType == '01'">
                <div style="display: flex; justify-content: space-around" v-if="item.status == '02'">
                  <div style="display: flex; flex-direction: column; justify-content: center; align-items: center">
                    <div class="ptText_1">拼团中</div>
                    <div class="ptText_2">拼团状态</div>
                  </div>
                  <div style="display: flex; flex-direction: column; justify-content: center; align-items: center">
                    <div class="ptText_1">{{ formatTime(item.remainingMillis) }}</div>
                    <div class="ptText_2">拼团倒计时</div>
                  </div>
                  <div style="display: flex; flex-direction: column; justify-content: center; align-items: center">
                    <div class="ptText_3" @click="inviteNewUsers(item.shareUrl)">复制链接</div>
                    <div class="ptText_2">拼团链接</div>
                  </div>
                </div>
                <div style="display: flex; flex-direction: column; align-items: center" v-if="item.status == '01'">
                  <div class="ptText_4"><span>拼团状态：</span> <span style="color: #ff2d31">拼团失败</span></div>

                  <div class="ptText_5" @click="gotoXuanke">去选课再拼团 <img src="../../assets/new/right-pt.png" alt="" /></div>
                </div>
                <div style="display: flex; flex-direction: column; align-items: center" v-if="item.status == '04'">
                  <div class="ptText_4"><span>拼团状态：</span> <span style="color: #ff8833">拼团成功</span></div>
                </div>
              </div> -->
              <!-- <div class="btn">
                <div class="btn_1" @click="handleinvoice">开发票</div>
                <div class="btn_2" @click="delOrder(item.id)">删除订单</div>
                <div class="btn_3">去支付</div>
              </div> -->
            </div>
            <div @click="loadMore" v-if="hasMore" class="load-more">点击加载更多</div>
            <div v-else class="no-more">没有更多数据了~</div>
          </div>
          <!-- 空状态 -->
          <van-empty description="暂无订单" v-if="orderList.length == 0" />
        </van-tab>
        <van-tab title="未支付">
          <div class="group_1" v-if="orderList.length > 0">
            <div class="box_1" v-for="item in orderList" :key="item.id">
              <div class="title">
                <div class="title_1">
                  <div class="text_1">{{ item.className }}</div>
                  <div class="text_2">订单编号：{{ item.ordNo }}</div>
                </div>
                <div class="title_icon" v-if="item.ordStatus == '20'">已支付</div>
                <div class="title_icon1" v-if="item.ordStatus == '01'">未支付</div>
                <div class="title_icon" v-if="item.ordStatus == '00'">已取消</div>
                <div class="title_icon" v-if="item.ordStatus == '10'">已退款</div>
                <div class="title_icon1" v-if="item.ordStatus == '02'">支付中</div>
                <div class="title_icon" v-if="item.ordStatus == '11'">部分退款</div>
                <div class="title_icon" v-if="item.ordStatus == '12'">申请退款</div>
              </div>
              <van-divider />
              <div class="info">
                <div class="info-left">
                  <img :src="item.image" alt="" v-if="item.image != null && item.image != '' && item.ordType != '05'" />
                  <img src="../../assets/new/orderVip.png" alt="" v-if="item.ordType == '05'" />
                  <img src="../../assets/new/xiaoBg.png" alt="" v-if="(item.image == null || item.image == '') && item.ordType != '05'" />
                </div>
                <div class="info-right">
                  <div class="text_3">下单时间：{{ item.createTime }}</div>
                  <div class="text_3">
                    订单类型：{{
                      item.ordType == '01'
                        ? '个人'
                        : item.ordType == '02'
                        ? '集体'
                        : item.ordType == '03'
                        ? '机构'
                        : item.ordType == '04'
                        ? '单课购买'
                        : item.ordType == '05'
                        ? '年度会员'
                        : '职业培训'
                    }}
                  </div>
                  <div class="text_4"><span class="text_5">¥</span>{{ item.ordTotalMoney.toFixed(2) }}</div>
                </div>
              </div>
              <van-divider />
              <div class="btn">
                <!-- <div class="btn_1" @click="handleinvoice">开发票</div> -->
                <div class="btn_2" @click="delOrder(item.id, '03')" v-if="item.ordStatus == '00'">删除订单</div>
                <div class="btn_2" @click="cancelOrder(item, '03')" v-if="item.ordStatus == '01'">取消订单</div>

                <div class="btn_3" v-if="item.ordStatus == '01'" @click="toOrder(item)">去支付</div>
              </div>
            </div>
            <div @click="loadMore" v-if="hasMore" class="load-more">点击加载更多</div>
            <div v-else class="no-more">没有更多数据了~</div>
          </div>
          <!-- 空状态 -->
          <van-empty description="暂无未支付订单" v-if="orderList.length == 0" />
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { toOrderList, toDeleterOrder, doCancelOrder } from '@/api/order.js';
import { toGenerateOrder } from '@/api/classDetail';
import { Dialog } from 'vant';
import { toTradeQuery } from '@/api/order';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      orderList: [],
      pageSize: 10,
      pageNum: 1,
      orderStatus: '',
      name: '0',
      total: '',
      hasMore: true,
      timers: {}
    };
  },

  computed: {},

  // 方法集合
  methods: {
    startCountdown() {
      this.clearTimers(); // 防止重复启动

      this.orderList.forEach((item, index) => {
        if (item.status === '02' && item.remainingMillis > 0) {
          this.timers[item.id] = setInterval(() => {
            item.remainingMillis -= 1000;

            if (item.remainingMillis <= 0) {
              item.remainingMillis = 0;
              item.status = '01';
              this.$set(this.orderList, index, { ...item });
              this.clearTimer(item.id);
              return;
            }

            this.$set(this.orderList, index, { ...item });
          }, 1000);
        }
      });
    },

    // 清除指定定时器
    clearTimer(id) {
      if (this.timers[id]) {
        clearInterval(this.timers[id]);
        delete this.timers[id];
      }
    },

    // 清除所有定时器
    clearTimers() {
      Object.keys(this.timers).forEach(id => {
        clearInterval(this.timers[id]);
      });
      this.timers = {};
    },

    // 格式化时间为 HH:mm:ss
    formatTime(millis) {
      if (millis <= 0) return '00:00:00';
      const totalSeconds = Math.floor(millis / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    },

    //复制链接
    inviteNewUsers(shareUrl) {
      const textarea = document.createElement('textarea');
      if (shareUrl != null && shareUrl != '') {
        textarea.value = shareUrl;
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        try {
          document.execCommand('copy');
          this.$utils.showToast('复制成功！');
          this.tip = '复制成功！';
          setTimeout(() => {
            this.tip = '';
          }, 2000);
        } catch (err) {
          this.$utils.showToast('复制失败！');
        }
        document.body.removeChild(textarea);
      } else {
        this.$utils.showToast('复制失败！');
      }
    },
    //切换tab
    onClick(name, title) {
      this.pageNum = 1;
      if (name == '0') {
        this.name == '0';
        this.$nextTick(() => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        });

        this.getList('01');
      } else if (name == '1') {
        this.name == '1';

        this.$nextTick(() => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        });
        this.getList('02');
      } else if (name == '2') {
        this.name == '2';

        this.$nextTick(() => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        });
        this.getList('03');
      }
    },
    //去开发票
    handleinvoice(item) {
      this.$router.push({
        path: '/invoicing',
        query:{
          id:item.id
        }
      });
    },
    //去选课
    gotoXuanke() {
      this.$router.push({
        path: '/chooseClass'
      });
    },
    //获取订单列表
    getList(type = 'all') {
      const data = {
        type,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };

      toOrderList(data).then(res => {
        const newRows = res.data.rows.map(row => {
          return {
            ...row,
            remainingMillis: Number(row.remainingMillis) || 0
          };
        });

        if (this.pageNum === 1) {
          this.orderList = newRows;
        } else {
          this.orderList = [...this.orderList, ...newRows];
        }

        this.total = res.data.total;
        this.hasMore = this.orderList.length < this.total;

        // 启动倒计时
        this.startCountdown();
      });
    },
    //去支付
    toOrder(item) {
      if (item.ordMoneysum == 0) {
        //订单金额为0元的
        this.$utils.showToast('该订单金额为0元，请取消订单重新购买！');
        return false;
      }
      let data = {
        orderId: item.id,
        createTime: item.createTime,
        orderNo: item.ordNo,
        payMoney: item.ordMoneysum,
        ordStatus: item.ordStatus,
        payTime: item.surplusTime,
        remainedTime: item.remainedTime
      };
      this.$router.push({
        path: '/payType',
        query: data
      });
    },
  goBack() {
  if (this.$route.query.type === 'success') {
    this.$router.push('/myClass');
    return;
  } else {
    this.$router.replace('/my');
  }
},
    loadMore() {
      this.pageNum++;
      if (this.name == '0') {
        this.getList('01');
      } else if (this.name == '1') {
        this.getList('02');
      } else if (this.name == '2') {
        this.getList('03');
      }
    },
    //删除订单
    delOrder(id, index) {
      this.$utils
        .showConfirm({
          title: '温馨提示',
          message: '确定删除该条数据?'
        })
        .then(() => {
          this.pageNum == 1;
          toDeleterOrder({ orderId: id }).then(res => {
            // this.$utils.showToast(res.data.msg);
            this.getList(index);
          });
        })
        .catch(() => {});
    },
    //取消订单
    cancelOrder(item, index) {
      //先对账查看订单是否已支付
      toTradeQuery({ orderId: item.id, ordPayType: item.ordPayType })
        .then(res => {
          const result = res?.data?.data?.result;
          if (result !== '2') {
            this.$utils.showToast('该订单已支付成功！');
            this.getList('01');
          } else {
            this.$utils
              .showConfirm({
                title: '温馨提示',
                message: '确定取消该订单?'
              })
              .then(() => {
                this.pageNum == 1;
                doCancelOrder({ orderId: item.id }).then(res => {
                  console.log(res);
                  // this.$utils.showToast(res.data.msg);
                  this.getList(index);
                });
              })
              .catch(() => {});
          }
        })
        .catch(err => {
          console.error('对账请求失败:', err);
        });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getList('01');
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // this.getList('01');
  },
  beforeDestroy() {
    this.clearTimers();
  },
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.page {
  background-color: #f6f8fa;
  height: 100vh;
  overflow-y: scroll;
}
.load-more,
.no-more {
  text-align: center;
  padding: 10px;
  font-size: 14px;
  color: #999;
}
.no-more {
  color: #666;
}
.group_1 {
  overflow-y: scroll;
  min-height: 100vh;
  // padding-bottom:100px;
  padding: 56px 15px 120px 15px;
  .box_1 {
    // width: 345px;
    margin-bottom: 10px;
    padding: 16px 15px;
    // height: 256px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    .title {
      display: flex;
      justify-content: space-between;
      .title_icon {
        width: 56px;
        height: 26px;
        background: #efefef;
        border-radius: 2px 2px 2px 2px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #777777;
        text-align: center;
        line-height: 26px;
      }
      .title_icon1 {
        width: 56px;
        height: 26px;
        background: rgba(255, 45, 49, 0.1);
        border-radius: 2px 2px 2px 2px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #ff2d31;
        text-align: center;
        line-height: 26px;
      }
      .title_1 {
        .text_1 {
          width: 200px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 15px;
          color: #333333;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .text_2 {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #999999;
        }
      }
    }
    .info {
      display: flex;
      .info-left {
        width: 110px;
        height: 88px;
        background: #d9d9d9;
        border-radius: 8px 8px 8px 8px;
        img {
          width: 110px;
          height: 88px;
          background: #d9d9d9;
          border-radius: 8px 8px 8px 8px;
        }
      }
      .info-right {
        margin-left: 12px;
        .text_3 {
          width: 200px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 13px;
          color: #333333;
          margin-bottom: 6px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin-top: 11px;
        }
        .text_4 {
          font-size: 17px;
          color: #ff2d31;
        }
        .text_5 {
          font-size: 12px;
          color: #ff2d31;
        }
      }
    }
  }
}  .btn_1 {
    width: 76px;
    height: 32px;
    border-radius: 16px 16px 16px 16px;
    border: 1px solid #2a70f2;
    color: #2a70f2;
    text-align: center;
    line-height: 32px;
    margin-left: 12px;
  }
.btn {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  display: flex;
  justify-content: flex-end;

  .btn_2 {
    width: 76px;
    height: 32px;
    border-radius: 16px 16px 16px 16px;
    border: 1px solid #666666;
    color: #666666;
    text-align: center;
    margin-left: 12px;
    line-height: 32px;
  }
  .btn_3 {
    width: 76px;
    height: 32px;
    background: linear-gradient(97deg, #2a70f2 0%, #669cff 100%);
    border-radius: 16px 16px 16px 16px;
    color: #ffffff;
    text-align: center;
    margin-left: 12px;
    line-height: 32px;
  }
}
::v-deep {
  .van-tabs__line {
    width: 24px;
    height: 2px;
    border-radius: 2px 2px 2px 2px;
    margin-bottom: 4px;
  }
  .van-tabs__wrap {
    position: fixed;
    top: 46px;
    z-index: 99;
    left: 0;
    width: 100%;
  }
  // .van-tabs__content {
  //   overflow-y: scroll;
  //   margin-top: 46px;
  // }
  // .van-nav-bar{
  //   position: fixed !important;
  //   width: 100%;
  //   top: 0;
  // }
}
.headerNav {
  position: fixed;
  top: 0;
  width: 100%;
  height: 46px;
  background: #fff;
  border-radius: 0px 0px 0px 0px;
  z-index: 99;
}
.nav {
  padding: 0 15px;
  height: 46px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.nav-left {
  position: absolute;
  top: 15px;
  left: 15px;
}
.nav_content {
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 17px;
  color: #333;
}
::v-deep {
  .van-tabs__content {
    // margin: 56px 0;
    // padding: 0 15px;
    // padding:56px 15px;
    height: 100vh;
    // overflow-y: scroll;
  }
  .van-tabs {
    overflow-y: scroll;
    position: fixed;
    top: 46px;
    left: 0;
    right: 0;
    width: 100%;
    margin-bottom: 60px;
  }
}
.btn_5 {
  padding: 10px;
  width: 100%;
  height: auto;
  background: rgba(255, 136, 51, 0.1);
  border-radius: 8px 8px 8px 8px;
  .ptText_1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 15px;
    color: #ff8833;
  }
  .ptText_2 {
    margin-top: 7px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #666666;
  }
  .ptText_4 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #666666;
  }
  .ptText_5 {
    display: flex;
    align-items: center;
    margin-top: 4px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #ff8833;
    img {
      width: 12px;
      height: 12px;
    }
  }
  .ptText_3 {
    padding: 4px 9px;

    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #ff8833;
    border-radius: 12px 12px 12px 12px;
    border: 1px solid #ff8833;
  }
}
</style>
